export const singleMarkerIcons = {
    'available': {
        'supported': {
            'src': require('assets/marker-icons/icon-available-supported.png'),
            'width': 37.8,
            'height': 42.44
        },
        'unsupported': {
            'src': require('assets/marker-icons/icon-available-unsupported.png'),
            'width': 41,
            'height': 47
        },
        'fast': {
            'src': require('assets/marker-icons/icon-available-fast.png'),
            'width': 37.8,
            'height': 42.44
        },
        'shell': {
            'src': require('assets/marker-icons/icon-available-shell.png'),
            'width': 43.2,
            'height': 43.79
        }
    },
    'occupied': {
        'supported': {
            'src': require('assets/marker-icons/icon-occupied-supported.png'),
            'width': 37.8,
            'height': 42.44
        },
        'unsupported': {
            'src': require('assets/marker-icons/icon-occupied-unsupported.png'),
            'width': 41,
            'height': 47
        },
        'shell': {
            'src': require('assets/marker-icons/icon-occupied-shell.png'),
            'width': 43.2,
            'height': 43.79
        }
    },
    'unknown': {
        'supported': {
            'src': require('assets/marker-icons/icon-unknown-supported.png'),
            'width': 37.8,
            'height': 42.44
        },
        'unsupported': {
            'src': require('assets/marker-icons/icon-unknown-unsupported.png'),
            'width': 41,
            'height': 47
        },
        'shell': {
            'src': require('assets/marker-icons/icon-unknown-shell.png'),
            'width': 43.2,
            'height': 43.79
        }
    },
    'unavailable': {
        'supported': {
            'src': require('assets/marker-icons/icon-unavailable-supported.png'),
            'width': 37.8,
            'height': 42.44
        },
        'unsupported': {
            'src': require('assets/marker-icons/icon-unavailable-unsupported.png'),
            'width': 41,
            'height': 47
        },
        'shell': {
            'src': require('assets/marker-icons/icon-unavailable-shell.png'),
            'width': 43.2,
            'height': 43.79
        }
    },
    'error': {
        'supported': {
            'src': require('assets/marker-icons/icon-unavailable-supported.png'),
            'width': 37.8,
            'height': 42.44
        },
        'unsupported': {
            'src': require('assets/marker-icons/icon-unavailable-unsupported.png'),
            'width': 41,
            'height': 47
        },
        'shell': {
            'src': require('assets/marker-icons/icon-unavailable-shell.png'),
            'width': 43.2,
            'height': 43.79
        }
    }
}

export const connectorIcons = {
    domestic: require('assets/connectors/domestic.svg'),
    saej1772: require('assets/connectors/saej1772.svg'),
    tepcochademo: require('assets/connectors/tepcochademo.svg'),
    type1: require('assets/connectors/type1.svg'),
    type1combo: require('assets/connectors/type1combo.svg'),
    type2: require('assets/connectors/type2.svg'),
    type2combo: require('assets/connectors/type2combo.svg'),
    type3: require('assets/connectors/type3.svg'),
    unknown: require('assets/connectors/unknown.svg')
}

export const icons = {
    searchByLocationExternalId: require('assets/icons/chargepoint.svg'),
    searchByLocation: require('assets/icons/location.svg'),
    myPosition: require('assets/icons/my-position.svg'),
    filterOn: require('assets/icons/filter_on.svg'),
    filterOff: require('assets/icons/filter_off.svg'),
    meMarker: require('assets/current-location.svg'),
    empty: require('assets/marker-icons/empty.png')
}
